<template>
  <nav class="culture-nav" aria-label="The Reckon Way sections">
    <v-container class="culture-nav-inner">
      <router-link :to="{ name: 'reckon-way-the-way' }">The Way</router-link>
      <router-link :to="{ name: 'reckon-way' }" exact>Journeys</router-link>
      <router-link :to="{ name: 'reckon-way-traditions' }">Traditions</router-link>
      <router-link :to="{ name: 'reckon-way-places' }">Local Places</router-link>
      <router-link :to="{ name: 'reckon-way-people' }">People</router-link>
    </v-container>
  </nav>
</template>

<script>
export default { name: 'CultureNav' };
</script>

<style scoped>
.culture-nav { background: #0b0b0b; border-bottom: 1px solid #292929; border-top: 1px solid #292929; position: sticky; top: 0; z-index: 5; }
.culture-nav-inner { display: flex; gap: 8px; overflow-x: auto; padding-bottom: 10px; padding-top: 10px; scrollbar-width: none; }
.culture-nav-inner::-webkit-scrollbar { display: none; }
a { border-radius: 999px; color: #c7c7c7; flex: 0 0 auto; font-family: "Oswald", sans-serif; font-size: .84rem; font-weight: 800; padding: 8px 15px; text-decoration: none; text-transform: uppercase; }
a:hover, a:focus, a.router-link-active { background: #e23232; color: #fff; }
</style>
